"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth0_react_1 = require("@auth0/auth0-react");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const ScopeGuard_1 = __importDefault(require("../../../common/js/components/security/ScopeGuard"));
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const translation_1 = require("../../../common/js/helper/translation");
const withAuthorization_1 = __importDefault(require("../../../common/js/hoc/withAuthorization"));
const CutterSlider_1 = __importDefault(require("../dashboard/CutterSlider"));
const DashboardDisrupter_1 = __importDefault(require("../dashboard/DashboardDisrupter"));
const Greetings_1 = __importDefault(require("../dashboard/Greetings"));
const NewsTeaser_1 = __importDefault(require("../dashboard/NewsTeaser"));
const OfferInfoBox_1 = __importDefault(require("../dashboard/OfferInfoBox"));
const ShortCuts_1 = __importDefault(require("../dashboard/ShortCuts"));
const SocialMedia_1 = __importDefault(require("../SocialMedia"));
class DashboardPage extends react_1.default.Component {
    componentDidMount() {
        document.title = (0, translation_1.t)('portal_subpage_title', { title: (0, translation_1.t)('dashboard.page_title') });
    }
    render() {
        return (react_1.default.createElement("section", { className: "znd-dashboard-page" },
            react_1.default.createElement(Greetings_1.default, null),
            react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.OFFER_READ] },
                react_1.default.createElement(OfferInfoBox_1.default, null)),
            react_1.default.createElement("div", { className: "row znd-dashboard-page__cutter-and-shortcuts" },
                react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.MACHINE_READ] },
                    react_1.default.createElement("div", { className: "col-xl-7 znd-dashboard-page__cutter m-xl-0" },
                        react_1.default.createElement(CutterSlider_1.default, null)),
                    react_1.default.createElement("div", { className: "w-100 d-block d-xl-none" })),
                react_1.default.createElement("div", { className: "col-xl-5" },
                    react_1.default.createElement(ShortCuts_1.default, null))),
            react_1.default.createElement(DashboardDisrupter_1.default, null),
            react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.NEWS_READ] },
                react_1.default.createElement(NewsTeaser_1.default, null)),
            react_1.default.createElement(SocialMedia_1.default, null)));
    }
}
exports.default = (0, auth0_react_1.withAuth0)((0, withAuthorization_1.default)({ scope: AuthorizationScopes_1.default.DASHBOARD })((0, mobx_react_1.observer)(DashboardPage)));
